<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import CustomLoader from "@/components/widgets/custom-loader";
import CustomFilter from "@/components/widgets/custom-filter";
import { mapActions, mapGetters } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Results Sheet",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    CustomLoader,
    CustomFilter,
  },
  data() {
    return {
      title: "Results Sheet",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Results Filter",
          href: "/",
        },
        {
          text: "ResultsSheet",
          active: true,
        },
      ],
      filterData: {
        class: "",
        course: "",
        date: "",
      },
      enableEdit: "",
      marksComments: [
        "AUSREICHEND - PASS", 
        "NICHT BESTANDEN - FAIL", 
        "SEHR GUT – VERY GOOD", 
        "GUT - GOOD", 
        "BEFRIEDIGEND - SATISFACTORY"
      ],
      currentDate: "",
      marksError: [],
    };
  },
  computed: {
    ...mapGetters("marks", [
      "SaveStatus",
      "getSpecificStudents",
      "getClassTeaches",
      "getYears",
    ]),
    ...mapGetters("students", ["FetchingStudents"]),
    ...mapGetters("classes", [
      "AllCourses",
      "TeacherSubjects",
      "CustomClasses",
    ]),
    ...mapGetters("auth", ["getCurrentUser"]),
  },
  watch: {
    SaveStatus(newVal) {
      if (!newVal) {
        // this.resetError();
        // this.closeModal(this.modal);
      }
    },
  },
  mounted() {},
  methods: {
    ...mapActions({
      FetchCourses: "classes/fetchCourses",
      FetchSpecificStd: "marks/fetchSpecificStd",
      SaveMarks: "marks/saveMarks",
      FetchClassTeaches: "marks/fetchClassTeaches",
      FetchYears: "marks/fetchYear",
      FetchCustomClasses: "classes/fetchCustomClasses",
    }),

    updateMarks(event, marksDetails, subjectId, inputType = "marks") {
      const inputValue = event.target.value;
      if (inputValue != "") {
        //set up object
        const marksDetailsObj = {
          course: marksDetails.enrolment_details.course.id,
          level: marksDetails.enrolment_details.class,
          sub: subjectId,
          date: marksDetails.date,
          inputType,
          sid: marksDetails.enrolment_details.student.id,
          enrol_id: marksDetails.enrolment_details.id
        };

        //assign input values to the object to be updated
        switch (inputType) {
          case "marks":
            marksDetailsObj.mark = inputValue;
            break;

          case "comment":
            marksDetailsObj.comment = inputValue;
            break;

          case "overall":
            marksDetailsObj.overall = inputValue;
            break;

          default:
            break;
        }
        this.SaveMarks(marksDetailsObj);
      }
    },
    setEnableEdit(comment) {
      this.enableEdit = comment;
    },
    setCurrentDate() {
      const today = new Date();

      // Format today as YYYY-MM-DD
      const year = today.getFullYear();
      const month = (today.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
      const day = today
        .getDate()
        .toString()
        .padStart(2, "0");
      this.currentDate = `${year}-${month}-${day}`;
      this.filterData.date = `${year}-${month}-${day}`;
    },
    submitFilter() {
      this.clearInputs();
      this.FetchSpecificStd(this.filterData);

      //reset enableCommentEditing
      this.enableEdit = "";
    },
    clearInputs() {
      // Select all elements with the class 'clearable-input'
      const inputs = document.querySelectorAll(".marks-holder");

      // Iterate over the selected elements and clear their values
      inputs.forEach((input) => {
        input.value = "";
      });
    },
    fetchTeachers() {
      const selectedClass = { classSelected: this.filterData.class };
      this.FetchClassTeaches(selectedClass);
    },
    fetchClasses() {
      const selectedCourse = { course: this.filterData.course };
      this.FetchCustomClasses(selectedCourse);
    },
  },
  created() {
    this.FetchYears();
    this.FetchCourses();
    this.setCurrentDate();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('enter_exam_marks')
        )
      "
    >
      <CustomFilter>
        <form @submit.prevent="submitFilter()">
          <div class="row">
            <!-- <div class="form-group col-md-2">
              <div class="form-group">
                <label for="">Year <small class="text-danger">*</small></label>
                <select
                  class="form-control form-control-sm"
                  v-model="filterData.year"
                  name=""
                  id=""
                >
                  <option value="" selected disabled>Select Year</option>
                  <option
                    v-for="(schyear, index) in getYears"
                    :value="schyear.year"
                    :key="index"
                  >
                    {{ schyear.year }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group col-md-2">
              <div class="form-group">
                <label for="">Month <small class="text-danger">*</small></label>
                <select
                  name="month"
                  required
                  v-model="filterData.month"
                  class="form-control form-control-sm"
                >
                  <option value="" selected disabled>Select Month</option>
                  <option value="01">January</option>
                  <option value="02">February</option>
                  <option value="03">March</option>
                  <option value="04">April</option>
                  <option value="05">May</option>
                  <option value="06">June</option>
                  <option value="07">July</option>
                  <option value="08">August</option>
                  <option value="09">September</option>
                  <option value="10">October</option>
                  <option value="11">November</option>
                  <option value="12">December</option>
                </select>
              </div>
            </div> -->
            <div class="form-group col-md-2">
              <div class="form-group">
                <label for=""
                  >Course <small class="text-danger">*</small></label
                >
                <select
                  required
                  class="form-control form-control-sm"
                  v-model="filterData.course"
                  name=""
                  id=""
                  @change="fetchClasses()"
                >
                  <option value="" selected disabled>Select Course</option>
                  <option
                    v-for="(course, index) in AllCourses"
                    :key="index"
                    :value="course.id"
                  >
                    {{ course.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group col-md-2">
              <div class="form-group">
                <label for="">Level <small class="text-danger">*</small></label>
                <select
                  required
                  class="form-control form-control-sm"
                  v-model="filterData.class"
                  @change="fetchTeachers()"
                  name=""
                  id=""
                >
                  <option value="" selected disabled>Select Level</option>
                  <option
                    v-for="(classes, index) in CustomClasses"
                    :key="index"
                    :value="classes.id"
                  >
                    {{ classes.short }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group col-md-2">
              <div class="form-group">
                <label for="">Date <small class="text-danger">*</small></label>
                <input
                  name="date"
                  type="date"
                  :max="this.currentDate"
                  required
                  v-model="filterData.date"
                  class="form-control form-control-sm"
                />
              </div>
            </div>
            <div class="col-md-2 mt-3">
              <button
                type="submit"
                size="sm"
                disabled
                class="btn btn-sm btn-outline-primary mt-2"
                v-if="FetchingStudents"
              >
                <b-spinner
                  variant="primary"
                  small
                  label="Fetching Data..."
                ></b-spinner>
                Fetching Data...
              </button>
              <button
                v-else
                type="submit"
                size="sm"
                class="btn btn-sm btn-outline-primary mt-2"
              >
                <i class="fa fa-check"></i>
                Submit Filers
              </button>
            </div>
          </div>
        </form>
      </CustomFilter>
      <CustomLoader v-if="FetchingStudents"></CustomLoader>
      <div v-else class="col-12">
        <div class="card" v-if="getSpecificStudents">
          <b-card
            class="mb-2"
            no-body
            v-for="(marksDetails, index) in getSpecificStudents"
            :key="index"
          >
            <b-row no-gutters class="mx-4 align-items-center">
              <b-col md="12">
                <b-card-body>
                  <h4
                    class="
                      card-title
                      text-uppercase
                      font-weight-bold
                      text-primary
                    "
                  >
                    {{ marksDetails.enrolment_details.student.name }}
                  </h4>
                  <h6>
                    <strong>
                      Course:
                      <span class="text-muted">
                        {{ marksDetails.enrolment_details.course.name }}</span
                      >
                      | Level:
                      <span class="text-success">
                        {{ marksDetails.enrolment_details.classx.short }}
                      </span>
                    </strong>
                  </h6>
                </b-card-body>
                <hr />
              </b-col>
            </b-row>
            <b-row no-gutters class="mx-5 align-items-center">
              <b-col
                md="3"
                v-for="(subject, sub_index) in marksDetails.std_results"
                :key="sub_index"
              >
                <b-card-body>
                  <h4 class="card-title ">{{ subject.subject.name }}</h4>
                  <input
                    @blur="
                      updateMarks($event, marksDetails, subject.subject.id)
                    "
                    :placeholder="
                      subject.results
                        ? subject.results.marks
                        : 'Please Enter a Mark'
                    "
                    class="form-control form-control marks-holder"
                    name=""
                    id=""
                  />
                  <!-- <br /> -->
                  <!-- <strong class="muted">Select Comment</strong>
                  <select
                    required
                    class="form-control form-control-sm"
                    name=""
                    id=""
                    @change="
                      updateMarks(
                        $event,
                        marksDetails,
                        subject.subject.id,
                        'comment'
                      )
                    "
                  >
                    <option
                      :value="subject.results.comment"
                      selected
                      disabled
                      v-if="subject.results && subject.results.comment != ''"
                      >{{ subject.results.comment }}</option
                    >
                    <option value="" selected disabled v-else
                      >Select Comment</option
                    >
                    <option
                      v-for="(comment, index) in marksComments"
                      :key="index"
                      :value="comment"
                    >
                      {{ comment }}
                    </option>
                  </select> -->
                </b-card-body>
              </b-col>
            </b-row>
            <b-row no-gutters class="mx-5 mb-4 align-items-center">
              <strong class="card-title">Overall Performance Comment</strong>
              <div v-if="marksDetails.std_comment" class="mb-2">
                Current Comment:
                <i>{{ marksDetails.std_comment.comment }} </i>
                <u>
                  <a
                    name=""
                    id=""
                    class="btn-sm btn-outline-primary"
                    role="button"
                    @click="
                      setEnableEdit({
                        comment: marksDetails.std_comment.comment,
                        sid: marksDetails.enrolment_details.student.id,
                      })
                    "
                  >
                    Click to Edit Comment</a
                  >
                </u>
              </div>
              <textarea
                v-if="
                  enableEdit != '' &&
                    enableEdit.sid == marksDetails.enrolment_details.student.id
                "
                class="form-control"
                v-model="enableEdit.comment"
                cols="5"
                rows="5"
                @blur="updateMarks($event, marksDetails, '0', 'overall')"
                placeholder="Please Enter Overall Comment"
              ></textarea>
              <textarea
                v-if="
                  !marksDetails.std_comment &&
                    enableEdit != '' &&
                    enableEdit.sid == marksDetails.enrolment_details.student.id
                "
                class="form-control"
                name=""
                id=""
                cols="5"
                rows="5"
                @blur="updateMarks($event, marksDetails, '0', 'overall')"
                placeholder="Please Enter Overall Comment"
              ></textarea>
              <textarea
                v-if="
                  !marksDetails.std_comment &&
                    enableEdit != '' &&
                    enableEdit.sid != marksDetails.enrolment_details.student.id
                "
                class="form-control"
                name=""
                id=""
                cols="5"
                rows="5"
                @blur="updateMarks($event, marksDetails, '0', 'overall')"
                placeholder="Please Enter Overall Comment"
              ></textarea>
              <textarea
                v-if="
                  !marksDetails.std_comment &&
                    enableEdit == '' &&
                    enableEdit.sid != marksDetails.enrolment_details.student.id
                "
                class="form-control"
                name=""
                id=""
                cols="5"
                rows="5"
                @blur="updateMarks($event, marksDetails, '0', 'overall')"
                placeholder="Please Enter Overall Comment"
              ></textarea>
            </b-row>
          </b-card>
        </div>
        <div class="card" v-else>
          <div class="card-body">
            <div class="alert alert-primary text-center" role="alert">
              <strong>Please filter students using the above inputs.</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
